import PolicyLayout from "./PolicyLayout";

export default function PrivacyPage() {
  return (
    <PolicyLayout
      title="Privacy Policy"
      updated="December 2025"
      testId="privacy-page"
    >
      <p>
        Me Amor respects your privacy. This policy explains what personal
        information we collect, why we collect it, how we protect it and your
        rights under the New Zealand Privacy Act 2020.
      </p>

      <h2>1. Information we collect</h2>
      <ul>
        <li>
          <strong>Contact details:</strong> name, email address and (when
          purchasing) shipping address and phone number.
        </li>
        <li>
          <strong>Order details:</strong> what you purchased, quantities,
          personalisation notes and order totals.
        </li>
        <li>
          <strong>Payment information:</strong> handled directly by Stripe.
          We do not see or store your full card number, CVV or expiry — we
          only receive a confirmation that a payment succeeded and the
          identifiers we need to fulfil your order.
        </li>
        <li>
          <strong>Newsletter sign-ups:</strong> email address (and optional
          name) if you opt into the Pen Pal Club.
        </li>
      </ul>

      <h2>2. How we use it</h2>
      <ul>
        <li>To process orders and deliver your gift boxes.</li>
        <li>
          To personalise boxes when you request personalisation (e.g. the
          birthday girl&apos;s name on the card).
        </li>
        <li>
          To send order confirmations, shipping updates and — with your
          consent — newsletters about new seasonal boxes and the Me Amor
          Salon.
        </li>
        <li>
          To manage subscriptions (renewals, cancellations, changes).
        </li>
        <li>
          To meet our legal, tax and accounting obligations in New Zealand.
        </li>
      </ul>

      <h2>3. Payment processing — Stripe</h2>
      <p>
        We use <strong>Stripe</strong> to process all payments. When you
        check out, your payment details are sent directly to Stripe (not to
        our servers) via a secure encrypted connection. Stripe is a
        PCI-DSS-compliant payment processor. Stripe&apos;s own privacy policy
        governs how they handle your payment data, and is available at{" "}
        <a
          href="https://stripe.com/privacy"
          target="_blank"
          rel="noreferrer"
        >
          stripe.com/privacy
        </a>
        .
      </p>

      <h2>4. Other service providers</h2>
      <ul>
        <li>
          <strong>Resend</strong> — used to send transactional emails (order
          confirmations, notifications).
        </li>
        <li>
          <strong>MongoDB Atlas / cloud database</strong> — used to store
          order and subscriber records.
        </li>
        <li>
          <strong>Emergent (hosting platform)</strong> — hosts our website
          and application infrastructure.
        </li>
      </ul>
      <p>
        Each provider is contractually bound to protect your information and
        may only use it to provide services to Me Amor.
      </p>

      <h2>5. Cookies</h2>
      <p>
        We use minimal browser storage (localStorage) to remember your basket
        between visits. We do not run behavioural advertising trackers on
        this site.
      </p>

      <h2>6. Children&apos;s data</h2>
      <p>
        Our products are designed as gifts for children aged 4–15, but the
        purchaser and account holder must be an adult. We do not knowingly
        collect personal information directly from children.
      </p>

      <h2>7. How long we keep your information</h2>
      <p>
        Order records are retained for a minimum of seven (7) years to
        satisfy New Zealand tax and business record requirements. Newsletter
        subscriptions are kept until you unsubscribe.
      </p>

      <h2>8. Your rights</h2>
      <p>
        Under the Privacy Act 2020 you have the right to access the personal
        information we hold about you and to request corrections. You can
        also request that we delete non-essential information (subject to
        our tax record-keeping obligations). Contact us at{" "}
        <a href="mailto:empower.meamor@gmail.com">
          empower.meamor@gmail.com
        </a>{" "}
        and we will respond within 20 working days.
      </p>

      <h2>9. Security</h2>
      <p>
        We use industry-standard practices to protect your information,
        including HTTPS across the website and secure hosted databases.
        However, no online transmission can be 100% secure.
      </p>

      <h2>10. Contact</h2>
      <p>
        Questions or complaints about this policy? Please email us at{" "}
        <a href="mailto:empower.meamor@gmail.com">
          empower.meamor@gmail.com
        </a>
        .
      </p>
    </PolicyLayout>
  );
}
